import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from '../assets/logo.png'

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/about', label: 'About' },
  { to: '/it-solutions', label: 'IT Solutions' },
  { to: '/contact', label: 'Contact' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(true)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setMenuOpen(false)
  }, [location])

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [menuOpen])

      const path = location.pathname

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container nav-container">
        <Link to="/" className="logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={logo} alt="TRED-EX AI" className="logo-img" />
    <div className="logo-text">
  <span
    className="logo-title"
    style={{
      background: "linear-gradient(90deg, #0066FF 0%, #008CFF 55%, #00CFFF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontWeight: "900",
      letterSpacing: "-0.5px"
    }}
  >
    TRED-EX
    <span
      className="logo-accent"
      style={{
        background: "linear-gradient(135deg, #FFD21F 0%, #FF8A00 45%, #FF3D00 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "900",
        marginLeft: "5px",
        filter: "drop-shadow(0 2px 6px rgba(255, 138, 0, 0.25))"
      }}
    >
      AI
    </span>
  </span>

  <span
    className="logo-subtitle"
    style={{
      color: "#173B8F",
      fontWeight: "600",
      letterSpacing: "0.4px"
    }}
  >
   Intelligent Sales. Automated Growth.
  </span>
</div>
        </Link>
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li className="nav-close-row">
            <span className="nav-menu-label">Menu</span>
            <button className="nav-close-btn" onClick={() => setMenuOpen(false)} aria-label="Close menu">
              <i className="fas fa-times"></i>
            </button>
          </li>
                              {NAV_ITEMS.map((item) => (
            <li key={item.label}>
              <Link
                to={item.to}
                className={path === item.to ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li className="nav-cta-mobile">
            <Link
              to="/contact"
              className="btn btn-primary btn-sm nav-cta"
              onClick={() => setMenuOpen(false)}
            >
              Enquiry Now
            </Link>
          </li>
        </ul>
        <div className="nav-actions">
          <Link
            to="/contact"
            className="btn btn-primary btn-sm nav-cta nav-cta-desktop"
            onClick={() => setMenuOpen(false)}
          >
            Enquiry Now
          </Link>
          <button className="hamburger" id="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
      <div className={`nav-backdrop ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(false)}></div>
    </nav>
  )
}
